module.exports = __webpack_public_path__ + "static/media/icon-smoking.9385ad3f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Hotel/images/amenities/icon-smoking.svg
// module id = 705
// module chunks = 6